export default __webpack_public_path__ + "media/images/features/local_delivery/cta_ttl_sp-b7d30c83a654e6205ccd745417f98019.png";